
import ClipboardJS from "clipboard";


export const convertToSnakeCase = (str) => str.toLowerCase().replace(/\s+/g, '_');


export const capitalizeText = (text) => {
  if (!text) return '';
  const lowercasedText = text.toLowerCase();
  return lowercasedText.charAt(0).toUpperCase() + lowercasedText.slice(1);
}


export function copyText(item) {

  const clipboard = new ClipboardJS('.btn', {
    text: () => item
  });

  clipboard.on("success", (e) => {
    // console.log("Texto copiado:", e.text);
    clipboard.destroy(); 
  });

  clipboard.on("error", (e) => {
    console.error("Error al copiar:", e);
    clipboard.destroy();  
  });
}


